import { LanguageCode } from 'i18n/internationalization.types';
import { BaseResponse } from 'models/_base';
import { UsageType } from './Common';

export enum SystemTemplates {
  ADJUSTMENT_BOOKING_CONFIRMED_AGENT = 'ADJUSTMENT_BOOKING_CONFIRMED_AGENT',
  AUTOMATED_REFUND_NOTICE_REFUND_FAILURE = 'AUTOMATED_REFUND_NOTICE_REFUND_FAILURE',
  AUTOMATED_REFUND_NOTICE_SUCCESSFUL_REFUND = 'AUTOMATED_REFUND_NOTICE_SUCCESSFUL_REFUND',
  AUTOMATED_REFUND_NOTICE_UPCOMING_REFUNDS = 'AUTOMATED_REFUND_NOTICE_UPCOMING_REFUNDS',
  BALANCE_DUE = 'BALANCE_DUE',
  BOOKING_ACCEPT = 'BOOKING_ACCEPT',
  BOOKING_DECLINED = 'BOOKING_DECLINED',
  BULK_EDIT_PROPERTY_LOGICAL_FAILURE = 'BULK_EDIT_PROPERTY_LOGICAL_FAILURE',
  CAPTURE_REVIEW = 'CAPTURE_REVIEW',
  CAPTURE_REVIEW_PROCEED = 'CAPTURE_REVIEW_PROCEED',
  CHARGE_USER = 'CHARGE_USER',
  EMAIL_SERVICE_PROVIDER = 'EMAIL_SERVICE_PROVIDER',
  EMAIL_SERVICE_PROVIDER_CANCEL = 'EMAIL_SERVICE_PROVIDER_CANCEL',
  FAILED_TRANSACTION_AGENT = 'FAILED_TRANSACTION_AGENT',
  FAILED_TRANSACTION_USER = 'FAILED_TRANSACTION_USER',
  GUEST_PRE_ARRIVAL_FORM_SUBMITTED = 'GUEST_PRE_ARRIVAL_FORM_SUBMITTED',
  INVITE_OWNER_TO_CLAIM_PROPERTY = 'INVITE_OWNER_TO_CLAIM_PROPERTY',
  INVITE_SP_TO_CLAIM_AGENCY = 'INVITE_SP_TO_CLAIM_AGENCY',
  INVITE_UNACTIVE_OWNER_TO_CLAIM_PROPERTY = 'INVITE_UNACTIVE_OWNER_TO_CLAIM_PROPERTY',
  INVITE_UNACTIVE_SP_TO_CLAIM_AGENCY = 'INVITE_UNACTIVE_SP_TO_CLAIM_AGENCY',
  JOB_DECLINED_AGENT = 'JOB_DECLINED_AGENT',
  JOB_DONE = 'JOB_DONE',
  JOB_SCHEDULED = 'JOB_SCHEDULED',
  LEAD_CAPTURE_WIDGET = 'LEAD_CAPTURE_WIDGET',
  LEAD_CONTRACT = 'LEAD_CONTRACT',
  NEW_BLOCKED_BY_OWNER = 'NEW_BLOCKED_BY_OWNER',
  NOTIFY_GUEST_NEW_MESSAGE = 'NOTIFY_GUEST_NEW_MESSAGE',
  NOTITY_OWNER_NEW_BOOKING = 'NOTITY_OWNER_NEW_BOOKING',
  NOTITY_OWNER_NEW_STATEMENT = 'NOTITY_OWNER_NEW_STATEMENT',
  ORDER_SERVICE_PURCHASE_NOTIFICATION = 'ORDER_SERVICE_PURCHASE_NOTIFICATION',
  OWNER_BLOCKED_RECEIVED = 'OWNER_BLOCKED_RECEIVED',
  OWNER_BLOCKED_UPDATED = 'OWNER_BLOCKED_UPDATED',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
  PLANNED_TRIP = 'PLANNED_TRIP',
  PRE_ARRIVAL_REMINDER = 'PRE_ARRIVAL_REMINDER',
  PRE_CHECKIN_NOTIFICATION = 'PRE_CHECKIN_NOTIFICATION',
  PROPERTY_AVAILABLE = 'PROPERTY_AVAILABLE',
  PROPERTY_AVAILABLE_NO_PAYMENT = 'PROPERTY_AVAILABLE_NO_PAYMENT',
  PROPERTY_MIN_STAY_INVALID = 'PROPERTY_MIN_STAY_INVALID',
  PROPERTY_ON_HOLD = 'PROPERTY_ON_HOLD',
  PROPERTY_ON_HOLD_NO_PAYMENT = 'PROPERTY_ON_HOLD_NO_PAYMENT',
  PROPERTY_ON_HOLD_REMINDER = 'PROPERTY_ON_HOLD_REMINDER',
  PROPERTY_ON_HOLD_REMINDER_NO_PAYMENT = 'PROPERTY_ON_HOLD_REMINDER_NO_PAYMENT',
  PROPERTY_SUGGESTER = 'PROPERTY_SUGGESTER',
  PROPERTY_UNAVAILABLE = 'PROPERTY_UNAVAILABLE',
  PROPERTY_UNAVAILABLE_OPTIONS = 'PROPERTY_UNAVAILABLE_OPTIONS',
  SECURE_PAYMENT_VRBO = 'SECURE_PAYMENT_VRBO',
  SERVICE_CONFIRMED_USER = 'SERVICE_CONFIRMED_USER',
  TRANSACTION_AGENT = 'TRANSACTION_AGENT',
  TRANSACTION_USER = 'TRANSACTION_USER',
  TRANSACTION_USER_FULL = 'TRANSACTION_USER_FULL',
  TRANSACTION_USER_NO_PAYMENT = 'TRANSACTION_USER_NO_PAYMENT',
  UNCAPTURED_TRANSACTION_AGENT = 'UNCAPTURED_TRANSACTION_AGENT',
  UNCAPTURED_TRANSACTION_USER = 'UNCAPTURED_TRANSACTION_USER',
}

export enum MessagingType {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
  WHATSAPP = 'WHATSAPP',
}

export enum MainRecipient {
  AGENT = 'AGENT',
  GUEST = 'GUEST',
  HOST = 'HOST',
  OWNER = 'OWNER',
}

export interface LocaleTO {
  content: string;
  subject: string;
  uid: string;
}

export enum ToggleTemplateAction {
  ENABLE = 'ENABLE',
  DISABLE = 'DISABLE',
}

export interface SystemTemplate {
  agencyUid: string;
  automaticallySent: boolean | null;
  enabled: boolean | null;
  htmlFile: string;
  key: SystemTemplates;
  locales: { [key in LanguageCode]?: LocaleTO };
  mainRecipient: MainRecipient;
  messagingType: MessagingType;
  name: string;
  propertyUid: string;
  sendCopyToAgency: boolean;
  uid: string;
  usageType: UsageType;
}

export interface GetSystemTemplatesResponse extends BaseResponse {
  templates: SystemTemplate[];
}

export interface UpdateSystemTemplatePayload {
  contents: { [key in LanguageCode]?: Pick<LocaleTO, 'subject' | 'content'> };
  sendCopyToAgency: boolean;
}

export interface SystemTemplateTogglePayload {
  templateKeys: SystemTemplates[];
  action: ToggleTemplateAction;
}

export interface SystemTemplateResetPayload {
  language: LanguageCode;
}

export interface SystemTemplatePreviewPayload {
  htmlContent: string;
  leadUid?: string;
  useSampleData?: boolean;
}

export interface SystemTemplatePreviewResponse {
  isSampleData: boolean;
  previewContent: string;
  previewTitle: string;
}
